module.exports = __webpack_public_path__ + "img/scanner-keyboard.8e353d73.svg";